import { PrizeTypes } from "../brandVariables.types";

// TODO(samsung): replace with the real Samsung prize + product image.
export const samsungPrize: PrizeTypes = {
  content: "Win a ",
  nameOf: "Samsung Prize", // will be marked in color
  typeOfItem: "", // will be added after nameOf

  // emptyPrize: "/static/images/tenants/samsung/prize.png",
};
